import { useTranslation } from 'react-i18next';
import styles from './ProdCards.module.less'

function Index({ ShowLinkOnly, list = [] }) {   
  const { t } = useTranslation();
  const jump = (href) => {
    window.open(href)
  };

  return (
    <div className={styles.products}>
      <div className={styles.list}>
        {
          list.map(item => (
            <a href="#a" key={item.qcmsdid} onClick={e => { e.preventDefault() }}>
              <img src={item.img_pc} alt={item.title} />
              <div className={`${styles.info} ${ShowLinkOnly ? styles.onlyLink : ''}`}>
                {
                  !ShowLinkOnly ? (
                    <>
                      <h4>{item.name}</h4>
                      <p>{item.brief}</p>
                    </>
                  ) : ''
                }
                {
                  item.gw_url ? <button onClick={ () => { jump(item.gw_url) } }>{ t('enterGW') }</button> : null
                }
                {
                  item.down_url ? 
                  <button onClick={ () => { jump(item.down_url) } }>{ t('download') }</button>
                  :
                  <button onClick={ () => { jump(item.down_url) } }>{ t('soon') }</button>
                }
              </div>
            </a>
          ))
        }
      </div>
    </div>
  );
}

export default Index;